import API from '@/api'
import { START_UP_2, START_UP_3 } from '@/common/js/enum'

export default {
  data() {
    return {
      isLocked: false
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    this.timer = null
  },
  methods: {
    /**
     * 判断配置中是否限制位置信息，若城市受限则 reject
     * @return {Promsie}
     */
    checkCitiesPromise() {
      if (process.env.NODE_ENV === 'development') {
        console.info('%c警告', 'color:#000;border-radius:4px;padding:2px 4px;background-color:orange;', '请不要再使用 init-mixin 内的 checkCitiesPromise 方法，请改用 checkCityLimit 方法')
      }

      return new Promise(async (resolve, reject) => {
        // 获取位置信息
        let activitiesLimit
        let activitiesMangerLimit
        try {
          activitiesLimit = this.$store.state.eventRuntime.common.limitCities && this.$store.state.eventRuntime.common.limitCities.length
        } catch (error) {
          activitiesLimit = null
        }
        try {
          activitiesMangerLimit = this.$store.state.activitiesManager.signUp.limitCities && this.$store.state.activitiesManager.signUp.limitCities.length
        } catch (error) {
          activitiesMangerLimit = null
        }
        if (activitiesLimit || activitiesMangerLimit) {
          let position
          // 地理位置授权
          try {
            position = await this.$wx.getLocation()
            this.$storage.setItem('latitude', position.latitude)
            this.$storage.setItem('longitude', position.longitude)
          } catch (error) {
            this.$vux.toast.show({
              text: '请授权位置信息以便进行活动',
              type: 'cancel',
              time: 1000
            })

            this.timer = setTimeout(() => {
              window.location.replace(window.location.origin + window.location.pathname)
            }, 1000)
            return false
          }

          try {
            await this._sendCheckCity(position)
          } catch (error) {
            this.$vux.toast.show({
              text: error.message || error,
              type: 'cancel',
              time: 1000
            })
            reject(error)
          }
        }
        resolve()
      })
    },

    /**
     * 判断配置中是否限制位置信息，若城市受限则 reject
     * @return {Promsie}
     */
    async checkCityLimit() {
      let activitiesLimit
      let activitiesMangerLimit

      try {
        activitiesLimit = this.$store.state.eventRuntime.common.limitCities && this.$store.state.eventRuntime.common.limitCities.length
      } catch (error) {
        activitiesLimit = null
      }

      try {
        activitiesMangerLimit = this.$store.state.activitiesManager.signUp.limitCities && this.$store.state.activitiesManager.signUp.limitCities.length
      } catch (error) {
        activitiesMangerLimit = null
      }

      if (activitiesLimit || activitiesMangerLimit) {
        let position

        try {
          position = await this.$wx.getLocation()
          this.$storage.setItem('latitude', position.latitude)
          this.$storage.setItem('longitude', position.longitude)
        } catch (err) {
          (process.env.NODE_ENV === 'development') && console.error(err)

          return {
            msg: err.message || '定位授权失败，请开启允许访问位置信息',
            granted: false
          }
        }

        try {
          await this._sendCheckCity(position)
        } catch (err) {
          (process.env.NODE_ENV === 'development') && console.error(err)

          return {
            msg: err.message,
            granted: false
          }
        }
      }

      return {
        granted: true
      }
    },

    /**
     * 调用发送 pv 记录接口
     */
    async sendPvInfo() {
      const uid = this.$storage.getItem('uid')
      const openid = this.$storage.getItem('openid')
      const token = this.$storage.getItem('token')
      if (uid) {
        await this._sendShareInfo({
          action: 'pv',
          activityId: this.$route.params.eventId,
          uid,
          openid,
          token
        })
      }
    },
    /**
     * 发送经纬度信息，判断是否处于受限城市
     * @param {object} position
     * @param {string | number} longitude 经度
     * @param {string | number} latitude 纬度
     * @return {promise}
    */
    async _sendCheckCity({latitude, longitude}) {
      this.$logoLoading.show()
      const resp = await this.$http({
        url: API.common.checkLimitCity,
        method: 'POST',
        params: {
          activity_id: this.$route.params.eventId,
          token: this.$storage.getItem('token'),
          openid: this.$storage.getItem('openid'),
          latitude,
          longitude
        }
      })

      this.$logoLoading.hide()

      if (+resp.status === 0) {
        throw new Error('您所在城市不支持该活动')
      }
    },
    /**
     * 分享成功 回调发送请求
     *
     * @param {string} action pv uv share_line share_friend
     * @param {string} activityId 活动id
     * @param {string} uid other_uid
     */
    async _sendShareInfo({ activityId, uid, openid, token, action = 'pv' } = {}) {
      const channel = this.$storage.getItem('prev_channel') || this.$storage.getItem('channel') || '0'
      const sid = this.$storage.getItem('sid') || '0'
      try {
        let resp = await this.$http({
          url: API.common.statistics,
          method: 'POST',
          params: {
            activity_id: activityId,
            user_id: uid,
            prev_uid: this.$storage.getItem('puid') != this.$storage.getItem('uid') ? this.$storage.getItem('puid') : 0,
            action,
            openid,
            token,
            channel,
            sid
          }
        })
        return resp
      } catch (error) {
        console.error(error)
      }
    },

    /**
     * 统计时长接口
     *
     * @param {string} action pv uv share_line share_friend
     * @param {string} activityId 活动id
     * @param {string} uid other_uid
     */
     _sendStayTime({ activityId, openid, token, type = '1' } = {}) {
        let resp = this.$http({
          url: API.common.stayTime,
          method: 'POST',
          params: {
            activity_id: activityId,
            type: type,
            openid,
            token
          }
        })
    },
    /**
     * 保存授权重定向后传过来的 token openid
     */
    getTokenFromUrl() {
      const search = window.location.search
      const configs = this.parseParams(search)
      this.$storage.remove('other_uid')
      this.$storage.remove('puid')
      this.$storage.remove('channel')
      this.$storage.remove('sub')
      this.$storage.remove('org_index')
      let keyArr = ['uid', 'other_uid', 'channel']
      keyArr.forEach(key => {
        if (configs[key]) {
          this.$storage.setItem(key, configs[key])
        }
      })
      if (configs['puid']){
        this.$storage.setItem('puid', configs['puid'])
      }
      if (configs['sid']){
        this.$storage.setItem('sid', configs['sid'])
      }
      const hashConfigs = this.parseParams(window.location.hash.slice(1))
      let arr = ['token', 'openid']
      arr.forEach(key => {
        if (hashConfigs[key]) {
          this.$storage.setItem(key, hashConfigs[key])
        }
      })
    },
    /**
     * 解析 url 参数
     * @param {String} str 形如 ?a=1&b=2
     * @return {Object} {a: 1, b: 2}
     */
    parseParams(str = '') {
      let ret = {}
      if (str.includes('?')) {
        str = str.replace('?', '')
      }
      if (str && str.includes('=')) {
        let arr = str.split('&')
        arr.map(d => {
          ret[d.split('=')[0]] = d.split('=')[1]
        })
      }
      return ret
    },
    _sendSubInfo() {
      this.$http({
        url: API.common.sendSubInfo,
        method: 'POST',
        params: {
          token: this.$storage.getItem('token'),
          openid: this.$storage.getItem('openid'),
          activity: this.$route.params.eventId || this.$route.params.orgId
        }
      })
    },
    async startUp() {
      this.$logoLoading.show()

      try {
        const openid = this.$storage.getItem('openid')
        const uid = this.$storage.getItem('uid') || 0
        const fid = this.$storage.getItem('other_uid') || 0

        let statusResp = await this.$http({
          url: API.common.startUp,
          method: 'POST',
          params: {
            openid,
            uid,
            fid,
            activity: this.$route.params.eventId || this.$route.params.orgId
          }
        })
        if(statusResp.self_uid){
          this.$storage.setItem('uid',statusResp.self_uid)
        }
        return statusResp
      } catch (err) {
        this.$vux.confirm.show({
          title: '错误',
          content: '状态信息获取失败，请刷新重试',
          showCancelButton: false,
          onConfirm: () => setTimeout(() => {
            window.location.reload()
          }, 300)
        })

        throw err
      } finally {
        this.$logoLoading.hide()
      }
    },
    /**
     * 设置引导关注
     */
    _setAdvance(watchDescription, publicAccountQRCode) {
      console.log(watchDescription)
      console.log(publicAccountQRCode)
      this.$watchDialog.init({
        watchDescription,
        publicAccountQRCode
      })
      return
      const that = this
      this.$vux.confirm.show({
        title: '温馨提示',
        confirmText: '现在关注',
        cancelText: '已关注不再提示',
        content: watchDescription,
        onCancel() {
          that._sendSubInfo()
        },
        onConfirm() {
          that.$vux.confirm.show({
            confirmText: '现在关注',
            cancelText: '已关注不再提示',
            title: '温馨提示',
            content: `<div><span style="text-align: center;">长按二维码识别关注</span><img height="200" width="200" src="${publicAccountQRCode}" alt="image"/></div>`,
            onCancel() {
              that._sendSubInfo()
            }
          })
        }
      })
    },
    /**
     * 根据配置设置分享信息
     */
    _setShareInfo(shareInfo, desc, imgUrl) {
      const uid = this.$storage.getItem('other_uid') || this.$storage.getItem('uid')
      const puid = this.$storage.getItem('uid')
      const openid = this.$storage.getItem('openid')
      const token = this.$storage.getItem('token')
      const activityId = this.$route.params.eventId
      const startUpStatus = this.$storage.getItem('start_up_status')

      const { title, useSetting } = shareInfo
      const shareBaseUrl = window.location.origin + window.location.pathname
      const channel = this.$storage.getItem('channel') || 0
      const getLink = _channel => {
        const isSpecailChannel = [0, 1, 2].some(d => +d === +channel)
        // const cl = isSpecailChannel ? _channel : channel
        const cl = channel
        let link
        let sid = this.$storage.getItem('sid') || '0'
        let staffInfo = window.localStorage.getItem(`WX_${'selfStaffInfo'.toString().toUpperCase()}`)
        if(!staffInfo){
          sid = 0
        }
        if (
          startUpStatus === START_UP_2 ||
          (startUpStatus === START_UP_3)
        ) {
          link = `${shareBaseUrl}?other_uid=${uid}&puid=${puid}&channel=${cl}&way=${_channel}&sid=${sid}`
        } else {
          link = `${shareBaseUrl}?channel=${cl}&puid=${puid}&way=${_channel}&sid=${sid}`
        }

        return link
      }

      if (useSetting) {
        this.$wx.shareWithFriend({
          title,
          desc,
          link: getLink(2),
          imgUrl
        }).then(() => {
          this._sendShareInfo({
            action: 'share_friend',
            activityId,
            uid,
            openid,
            token
          })
        }).catch(err => {
          if (window.localStorage.getItem('test') === '1') {
            this.$vux.confirm.show({
              title: '分享设置出错',
              content: err.message || err,
              showCancelButton: false
            })
          }
        })

        this.$wx.shareTimeline({
          title: desc,
          link: getLink(1),
          imgUrl
        }).then(() => {
          this._sendShareInfo({
            action: 'share_line',
            activityId,
            uid,
            openid,
            token
          })
        })
      } else {
        this.$wx.hideOptionMenu()
      }
    },
    /**
     * 请求 获取 wx 签名
     * 载入 wx sdk 配置
     */
    async setConfig(shareInfo, desc, imgUrl) {
      // 这个url必须以这样的方式获取，这是微信的要求
      // 否则 wx.config 方法无法设置后端返回的签名
      const url = window.location.origin + window.location.pathname + window.location.search
      const testMode = window.localStorage.getItem('test') === '1'

      let res = {}
      let args = {}

      try {
        res = await this.$http({
          method: 'POST',
          url: API.common.getWxSignature,
          params: { url }
        })
      } catch (err) {
        if (testMode) {
          this.$vux.confirm.show({
            title: '授权签名获取失败',
            content: ((err.message && err.message.errMsg) || err.message || err),
            showCancelButton: false
          })
        }

        this.$logoLoading.hide()
        throw err
      }

      try {
        args = {
          appId: res.appid,
          timestamp: res.timestamp,
          nonceStr: res.noncestr,
          signature: res.signature
        }

        await this.$wx.setConfig(args)
      } catch (err) {
        if (testMode) {
          this.$vux.confirm.show({
            title: '微信SDK配置出错',
            content: err.errMsg + '. API arguments: ' + JSON.stringify(args),
            showCancelButton: false
          })
        }

        throw err
      } finally {
        this.$logoLoading.hide()
      }

      shareInfo && this._setShareInfo(shareInfo, desc, imgUrl)
    },
    /**
     * 判断是否需要重定向
     * errcode 为 1 则重定向
     */
    async getWebUrl(writeOffAuth = false) {
      if (this.isLocked) {
        return false
      }

      this.isLocked = true

      const url = window.location.href.split('#')[0]
      const token = this.$storage.getItem('token')
      const openid = this.$storage.getItem('openid')
      const uid = this.$storage.getItem('uid') || 0

      let resData

      try {
        resData = await this.$http({
          method: 'POST',
          url: API.common.getWebUrl,
          params: {
            // 本地测试模式可开启
            url: ['http://192', 'http://localhost'].some(d => url.startsWith(d)) ? `http://wxmini.shenhudong.com/${this.$route.params.eventId || this.$route.params.orgId}` : url,
            // url,
            token,
            openid,
            uid,
            activity: writeOffAuth ? 0 : (this.$route.params.eventId || this.$route.params.orgId)
          }
        })
      } catch (err) {
        throw err
      } finally {
        this.isLocked = false
      }

      if (+resData.status === 1) {
        window.location.replace(resData.url)
        throw new Error('redirect')
      }

      this.$router.replace({
        ...this.$route,
        hash: '',
      })

      // 强行更新 token 使复制出的 token 与实际 token 不一致
      let resp
      try {
        resp = await this.$http({
          method: 'POST',
          url: API.common.updateToken,
          params: {
            token
          }
        })
        this.$storage.setItem('token', resp.token)
      } catch (error) {
        console.log(error)
      }


      return resData
    }
  }
}